<section class="mx-3">
    <div class="d-flex align-items-center">
        <div>
            <h4 translate class="m-0">Role Manage</h4>
        </div>
    </div>

    <div class="bg-white p-3 mt-2">
        <!-- Dropdown -->
        <div>
            <label translate class="form-label m-0">Module Name</label>
            <select class="form-select" (change)="onSelectionChange($event)">
                <option translate selected disabled [value]="null">Choose Option</option>
                <option *ngFor="let opt of moduleNames" [value]="opt.module_name">
                    {{ opt.module_name | removeUnderscore }}
                </option>
            </select>
        </div>

        <!-- Permissions Form -->
        <form [formGroup]="userForm" class="pt-3" (ngSubmit)="submitForm()">
            <div *ngIf="selected_module">

                <!-- Without submodules -->
                <div *ngIf="selected_module.sub_modules.length === 0" class="mb-3">
                    <div class="fw-bold">{{ selected_module.module_name | removeUnderscore }}</div>
                    <div class="d-flex flex-wrap gap-3 ">
                        <!-- Select All -->
                        <div class="form-check mb-2">
                            <input type="checkbox" class="form-check-input" [formControlName]="'selectAll'"
                                id="selectAll" />
                            <label translate class="form-check-label" for="selectAll">Select All</label>
                        </div>

                        <!-- Individual permissions -->
                        <div class="form-check" *ngFor="let action of ['Create','Edit','View','List']">
                            <input type="checkbox" class="form-check-input" [formControlName]="action"
                                id="{{action}}" />
                            <label class="form-check-label" [for]="action">{{action | removeUnderscore}}</label>
                        </div>
                    </div>
                </div>

                <!-- With submodules -->
                <div *ngIf="selected_module.sub_modules.length > 0">
                    <div *ngFor="let sub_module of selected_module.sub_modules" class="mb-3">
                        <div class="fw-bold">{{ sub_module.sub_module_name | removeUnderscore }}</div>
                        <div class="d-flex flex-wrap gap-3 ">
                            <!-- Select All for submodule -->
                            <div class="form-check mb-2">
                                <input type="checkbox" class="form-check-input"
                                    [formControlName]="sub_module.sub_module_name + '_selectAll'"
                                    id="{{sub_module.sub_module_name}}_selectAll" />
                                <label translate class="form-check-label" [for]="sub_module.sub_module_name + '_selectAll'">Select
                                    All</label>
                            </div>

                            <!-- Individual permissions -->
                            <div class="form-check" *ngFor="let action of permissionkeys">
                                <input type="checkbox" class="form-check-input"
                                    [formControlName]="sub_module.sub_module_name + '_' + action"
                                    id="{{sub_module.sub_module_name + '_' + action}}" />
                                <label class="form-check-label"
                                    [for]="sub_module.sub_module_name + '_' + action">{{action | removeUnderscore}}</label>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <button translate type="submit" class="btn btn-primary mt-3">Save</button>
        </form>
    </div>
</section>